/* ============================================================
   Quiz "Trova la tua pianta" - I Giardini di Giulia
   Nuova versione (decisione della titolare, 09/10/2026), testi definitivi scelti dal titolare.
   - Dati: templates/collection.quiz-dati.liquid, letti solo quando il quiz si apre
     (metafield quiz.percorso e filtri.*). Nessuna richiesta a servizi esterni, nessun modulo.
   - Una domanda per schermata; risultati con "Aggiungi al carrello" e "Scopri".
   - Percorso pianta: il budget e un filtro sui risultati (Tutti / Fino a 30 / 30-70 / Oltre 70).
   - Si apre con window.ggqOpen(), con ?quiz=1 o #quiz; sulla pagina "Trova la tua pianta"
     viene mostrato dentro la pagina ([data-ggq-inline]).
   ============================================================ */
(function () {
  'use strict';
  if (window.__ggqBooted) return;
  window.__ggqBooted = true;

  var config = window.GGQ_CONFIG || {};
  if (config.enabled === false) return;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var DATI = ROOT + 'collections/all?view=quiz-dati&page=';
  var NS = '__ns';

  // ---------- utilita ----------
  function e(v) { return String(v == null ? '' : v).replace(/[&<>'"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[c]; }); }
  function euro(cent) { var x = (cent / 100).toFixed(2).split('.'); return '€ ' + x[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + x[1]; }
  function lista(v) { return Array.isArray(v) ? v : (v == null || v === '' ? [] : [v]); }
  function ha(v, x) { return lista(v).indexOf(x) !== -1; }
  function low(s) { return String(s || '').toLowerCase(); }
  var ICONE = {
    check: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>',
    close: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    back: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>',
    leaf: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22V11"/><path d="M12 11c0-4 3-7 7-7 0 4-3 7-7 7Z"/><path d="M12 15c0-3-2-5-5-5 0 3 2 5 5 5Z"/></svg>'
  };

  // ---------- testi definitivi del titolare ----------
  // opzioni: [valore, risposta, spiegazione]; ns: spiegazione di "Non saprei" (solo dove previsto)
  function budget(extra) { return { id: 'budget', titolo: 'Che budget hai?', opzioni: [['b30', 'Fino a 30 €', ''], ['b70', '30-70 €', ''], ['b70p', 'Oltre 70 €', extra || '']] }; }
  var DOMANDE = {
    cerca: { titolo: 'Cosa stai cercando?', opzioni: [
      ['pianta', 'Una pianta da interno', 'Per casa o ufficio, verde o fiorita'],
      ['bonsai', 'Un bonsai', 'Da coltivare, anche se è il primo'],
      ['senza-cure', 'Verde che non ha bisogno di cure', 'Niente acqua né luce: quadri, pareti e bonsai stabilizzati'],
      ['regalo', 'Un regalo', 'Per un\'occasione, un amico o i clienti'],
      ['arredo', 'Un vaso o un oggetto d\'arredo', 'Vasi, lampade e oggetti per la casa'] ] },
    stanza: { titolo: 'Dove la vuoi mettere?', opzioni: [
      ['Soggiorno', 'Soggiorno', 'La stanza dove passi più tempo'],
      ['Camera da letto', 'Camera da letto', 'Piante che stanno bene dove si dorme'],
      ['Cucina', 'Cucina', 'Anche vicino al calore e al vapore'],
      ['Bagno', 'Bagno', 'Amano l\'umidità'],
      ['Ufficio', 'Ufficio o studio', 'Sulla scrivania o vicino al tavolo di lavoro'],
      ['esterno', 'Balcone, terrazzo o giardino', 'All\'aperto, tutto l\'anno'] ] },
    luce: { titolo: 'Quanta luce c\'è in quel punto?', ns: 'Ti consigliamo piante che si adattano', opzioni: [
      ['Tanta luce', 'Tanta luce', 'Vicino a una finestra, anche con un po\' di sole'],
      ['Luce indiretta', 'Luce indiretta', 'Luminoso, ma senza sole diretto sulle foglie'],
      ['Poca luce', 'Poca luce', 'Lontano dalle finestre o in una stanza in ombra'] ] },
    tempo: { titolo: 'Quanto tempo hai per curarla?', opzioni: [
      ['poco', 'Pochissimo, la dimentico spesso', 'Piante resistenti, che sopportano qualche dimenticanza'],
      ['medio', 'Il giusto, mi piace curarla', 'Annaffiature regolari e un po\' di attenzione'],
      ['tanto', 'Tanto, cerco una sfida', 'Piante più esigenti e spettacolari'] ] },
    animali: { titolo: 'Hai cani o gatti in casa?', opzioni: [
      ['si', 'Sì', 'Ti mostriamo solo piante non tossiche per cani e gatti secondo l\'ASPCA'], ['no', 'No', ''] ] },
    esperienza: { titolo: 'È il tuo primo bonsai?', opzioni: [
      ['primo', 'Sì, è il primo', 'Bonsai facili e resistenti, perfetti per iniziare'],
      ['esperto', 'No, ne ho già curati', 'Esemplari più particolari e impegnativi'] ] },
    dove_bonsai: { titolo: 'Dove lo terrai?', ns: 'Ti mostriamo i più adatti a chi inizia', opzioni: [
      ['Interno', 'In casa', 'Bonsai da interno, come il Ficus Ginseng'],
      ['Esterno', 'All\'aperto', 'Bonsai da esterno, come l\'olivo e il ginepro'] ] },
    dove_cure: { titolo: 'Dove lo vuoi mettere?', ns: 'Ti mostriamo i più scelti', opzioni: [
      ['parete', 'Su una parete', 'Quadri e pareti di muschio e licheni'],
      ['mobile', 'Su un mobile, una mensola o un tavolo', 'Bonsai Kumori e composizioni'] ] },
    per_chi: { titolo: 'A chi lo regali?', ns: 'I regali più scelti dai nostri clienti', opzioni: [
      ['ama', 'A chi ama le piante', 'Qualcosa di speciale da curare'],
      ['nopollice', 'A chi non ha il pollice verde', 'Regali belli che non richiedono cure o quasi'],
      ['azienda', 'A un collega, un cliente o un team', 'Regali aziendali curati e pronti da regalare'] ] },
    cosa_arredo: { titolo: 'Cosa cerchi?', opzioni: [
      ['vaso', 'Un vaso', 'Per una pianta che hai già o da abbinare'],
      ['lampada', 'Una lampada', 'Luce calda in ceramica e materiali naturali'],
      ['altro', 'Un oggetto d\'arredo', 'Orologi, diffusori e decorazioni'] ] }
  };
  function domandaDef(id, a) { if (id === 'budget') return budget(a.cerca === 'bonsai' ? 'Esemplari di pregio, anche da regalare' : ''); return DOMANDE[id]; }
  function percorsoDomande(a) {
    switch (a.cerca) {
      case 'pianta': return ['cerca', 'stanza'].concat(a.stanza === 'esterno' ? [] : ['luce']).concat(['tempo', 'animali']);
      case 'bonsai': return ['cerca', 'esperienza', 'dove_bonsai', 'budget'];
      case 'senza-cure': return ['cerca', 'dove_cure', 'budget'];
      case 'regalo': return ['cerca', 'per_chi', 'budget'];
      case 'arredo': return ['cerca', 'cosa_arredo', 'budget'];
      default: return ['cerca'];
    }
  }
  var TITOLI = {
    pianta: 'Le piante giuste per te', bonsai: 'I bonsai giusti per te', 'senza-cure': 'Verde vero, senza cure',
    regalo: 'Idee regalo scelte per te', arredo: 'Scelti per la tua casa'
  };
  var RIEPILOGO = {
    stanza: { 'Soggiorno': 'Soggiorno', 'Camera da letto': 'Camera da letto', 'Cucina': 'Cucina', 'Bagno': 'Bagno', 'Ufficio': 'Ufficio o studio', 'esterno': 'Balcone, terrazzo o giardino' },
    luce: { 'Tanta luce': 'Tanta luce', 'Luce indiretta': 'Luce indiretta', 'Poca luce': 'Poca luce', '__ns': 'Luce da valutare' },
    tempo: { poco: 'Poche cure', medio: 'Cure regolari', tanto: 'Pianta impegnativa' },
    animali: { si: 'Con animali', no: 'Senza animali' },
    esperienza: { primo: 'Primo bonsai', esperto: 'Già esperto' },
    dove_bonsai: { Interno: 'In casa', Esterno: 'All\'aperto', '__ns': 'Posizione da valutare' },
    dove_cure: { parete: 'Su una parete', mobile: 'Su un mobile o un tavolo', '__ns': 'Posizione da valutare' },
    per_chi: { ama: 'Per chi ama le piante', nopollice: 'Per chi non ha il pollice verde', azienda: 'Per colleghi e clienti', '__ns': 'I regali più scelti' },
    cosa_arredo: { vaso: 'Vaso', lampada: 'Lampada', altro: 'Oggetto d\'arredo' },
    budget: { b30: 'Fino a 30 €', b70: '30-70 €', b70p: 'Oltre 70 €' }
  };

  // ---------- dati ----------
  var dati = { lista: null, promessa: null };
  function caricaDati() {
    if (dati.lista) return Promise.resolve(dati.lista);
    if (dati.promessa) return dati.promessa;
    try {
      var c = JSON.parse(sessionStorage.getItem('ggqDati') || 'null');
      if (c && Date.now() - c.ts < 900000 && c.l && c.l.length) { dati.lista = c.l; return Promise.resolve(dati.lista); }
    } catch (x) {}
    function pagina(n) { return fetch(DATI + n, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) { return JSON.parse(t); }); }
    dati.promessa = pagina(1).then(function (prima) {
      var altre = [];
      for (var n = 2; n <= (prima.pagine || 1); n++) altre.push(pagina(n));
      return Promise.all(altre).then(function (resto) {
        var tutti = (prima.prodotti || []).slice();
        resto.forEach(function (d) { tutti = tutti.concat(d.prodotti || []); });
        dati.lista = tutti;
        try { sessionStorage.setItem('ggqDati', JSON.stringify({ ts: Date.now(), l: tutti })); } catch (x) {}
        return tutti;
      });
    }).catch(function (err) { dati.promessa = null; throw err; });
    return dati.promessa;
  }

  // ---------- logica ----------
  function ambienti(p) {
    var a = lista(p.a);
    if (a.length) return a;
    var t = low(p.ty);
    if (t.indexOf('esterno') !== -1 && t.indexOf('interno') === -1) return ['Esterno'];
    if (t.indexOf('interno') !== -1 && t.indexOf('esterno') === -1) return ['Interno'];
    return [];
  }
  function tipoArredo(p) {
    var t = low(p.t) + ' ' + low(p.ty);
    if (/\b(lume|lumi|lampada|lamp|fira|lamparium)\b|acqualum|gaud/.test(t)) return 'lampada';
    if (/\b(vaso|vasi|vasetto|fioriera|portavaso|portafiori|cachepot)\b/.test(t)) return 'vaso';
    return 'altro';
  }
  function aParete(p) { var t = low(p.t) + ' ' + low(p.ty); return /quadr|parete/.test(t); }
  function inBudget(p, b) {
    if (!b || b === NS || b === 'tutti') return true;
    if (b === 'b30') return p.p <= 3000;
    if (b === 'b70') return p.p > 3000 && p.p <= 7000;
    return p.p > 7000;
  }
  function rank(p) { return typeof p.rk === 'number' && p.rk > 0 ? p.rk : 999999; }
  function daRegalo(p) { return p.rg === true || lista(p.r).indexOf('regalo') !== -1; }

  // larghezza: 0 = tutto, 1 = senza budget, 2 = senza budget e senza stanza (interno/esterno)
  function candidati(a, larghezza) {
    var out = [];
    dati.lista.forEach(function (p) {
      var r = lista(p.r), punti = 0;
      if (!p.v || !p.p) return;
      // percorso
      if (a.cerca === 'pianta' && r.indexOf('pianta') === -1) return;
      if (a.cerca === 'bonsai' && r.indexOf('bonsai') === -1) return;
      if (a.cerca === 'senza-cure' && r.indexOf('senza-cure') === -1) return;
      if (a.cerca === 'arredo' && r.indexOf('arredo') === -1) return;
      if (a.cerca === 'regalo') {
        var reg = daRegalo(p);
        if (a.per_chi === 'azienda' || a.per_chi === NS) { if (!reg) return; }
        else if (a.per_chi === 'nopollice') { if (!(r.indexOf('senza-cure') !== -1 || ((r.indexOf('pianta') !== -1 || r.indexOf('bonsai') !== -1 || r.indexOf('regalo') !== -1) && (p.pm === true || p.lv === 'Principiante')))) return; }
        else if (a.per_chi === 'ama') { if (r.indexOf('pianta') === -1 && r.indexOf('bonsai') === -1) return; }
        if (reg) punti += 3;
      }
      // esclusioni
      if (larghezza < 1 && !inBudget(p, a.budget)) return;
      if (a.cerca === 'pianta') {
        if (a.animali === 'si' && p.pf !== true) return;
        if (a.stanza) {
          var serve = a.stanza === 'esterno' ? 'Esterno' : 'Interno', amb = ambienti(p);
          // all'aperto serve un'indicazione esplicita (dato Esterno o tipo "da esterno"): molte piante da interno non hanno il dato
          if (larghezza < 2 && (serve === 'Esterno' ? amb.indexOf('Esterno') === -1 : (amb.length && amb.indexOf('Interno') === -1))) return;
          if (amb.indexOf(serve) !== -1) punti += 2;
          if (a.stanza !== 'esterno' && ha(p.ip, a.stanza) && larghezza < 2) punti += 3;
        }
        if (a.luce && a.luce !== NS && ha(p.l, a.luce)) punti += 3;
        if (a.luce === NS && lista(p.l).length >= 2) punti += 2; // "piante che si adattano"
        if (a.tempo === 'poco' && (p.pm === true || p.lv === 'Principiante')) punti += 2;
        if (a.tempo === 'tanto' && p.lv === 'Esperto') punti += 2;
      }
      if (a.cerca === 'bonsai') {
        if (a.esperienza === 'primo' && p.lv === 'Principiante') punti += 3;
        if (a.esperienza === 'esperto' && (p.lv === 'Intermedio' || p.lv === 'Esperto')) punti += 3; // "Esemplari più particolari e impegnativi"
        if (a.dove_bonsai === NS && a.esperienza !== 'esperto' && p.lv === 'Principiante') punti += 2;
        if (a.dove_bonsai && a.dove_bonsai !== NS) {
          var ab = ambienti(p);
          if (larghezza < 2 && (a.dove_bonsai === 'Esterno' ? ab.indexOf('Esterno') === -1 : (ab.length && ab.indexOf('Interno') === -1))) return;
          if (ab.indexOf(a.dove_bonsai) !== -1) punti += 2;
        }
      }
      if (a.cerca === 'senza-cure' && a.dove_cure && a.dove_cure !== NS) {
        if ((a.dove_cure === 'parete') !== aParete(p)) return;
      }
      if (a.cerca === 'arredo' && a.cosa_arredo) {
        if (tipoArredo(p) !== a.cosa_arredo) return;
      }
      out.push({ p: p, punti: punti });
    });
    out.sort(function (x, y) { return (y.punti - x.punti) || (rank(x.p) - rank(y.p)) || (x.p.p - y.p.p); });
    return out;
  }

  var FRASI_LUCE = { 'Poca luce': 'Sta bene con poca luce', 'Luce indiretta': 'Ama la luce indiretta', 'Tanta luce': 'Vuole tanta luce' };
  var FRASI_STANZA = { 'Soggiorno': 'Perfetta per il soggiorno', 'Camera da letto': 'Perfetta per la camera da letto', 'Cucina': 'Perfetta per la cucina', 'Bagno': 'Perfetta per il bagno', 'Ufficio': 'Perfetta per l\'ufficio o lo studio' };
  function perche(p, a, migliore) {
    var parti = [], l = lista(p.l);
    if (a.animali === 'si' && p.pf === true) parti.push('Non tossica per cani e gatti secondo l\'ASPCA'); // prima, se ci sono animali
    if (a.luce && a.luce !== NS && l.indexOf(a.luce) !== -1) parti.push(FRASI_LUCE[a.luce]);
    else if (l.length && (a.cerca === 'pianta' || (a.cerca === 'regalo' && lista(p.r).indexOf('pianta') !== -1))) parti.push(FRASI_LUCE[l.indexOf('Poca luce') !== -1 ? 'Poca luce' : l[0]]);
    if (a.cerca === 'pianta' && a.stanza && a.stanza !== 'esterno' && ha(p.ip, a.stanza)) parti.push(FRASI_STANZA[a.stanza]);
    if (p.pm === true) parti.push('Resistente, perdona qualche dimenticanza');
    if (p.lv === 'Principiante' && a.esperienza !== 'esperto') parti.push('Ideale per iniziare');
    if (p.pf === true && a.animali !== 'si') parti.push('Non tossica per cani e gatti secondo l\'ASPCA');
    if ((a.stanza === 'esterno' || a.dove_bonsai === 'Esterno') && ambienti(p).indexOf('Esterno') !== -1) parti.push('Da coltivare all\'aperto');
    if (lista(p.r).indexOf('senza-cure') !== -1) parti.push('Non ha bisogno di acqua né di luce');
    var max = migliore ? 2 : 3;
    parti = parti.slice(0, max);
    if (migliore) parti.push('Tra le più scelte dai nostri clienti');
    return parti.join(' · ');
  }

  function linkCollezione(a) {
    var q = [], base;
    function prezzo() { if (a.budget === 'b30') q.push('filter.v.price.lte=30'); if (a.budget === 'b70') { q.push('filter.v.price.gte=30'); q.push('filter.v.price.lte=70'); } if (a.budget === 'b70p') q.push('filter.v.price.gte=70'); }
    if (a.cerca === 'pianta') {
      base = a.stanza === 'esterno' ? 'piante-da-esterno-1' : 'piante-verdi-da-interno';
      if (a.stanza && a.stanza !== 'esterno') q.push('filter.p.m.filtri.ideale_per=' + encodeURIComponent(a.stanza));
      if (a.tempo === 'poco') q.push('filter.p.m.filtri.poca_manutenzione=1');
      if (a.animali === 'si') q.push('filter.p.m.filtri.pet_friendly=1');
    } else if (a.cerca === 'bonsai') {
      base = 'bonsai';
      if (a.esperienza === 'primo') q.push('filter.p.m.filtri.livello=Principiante');
      if (a.dove_bonsai && a.dove_bonsai !== NS) q.push('filter.p.m.filtri.ambienti=' + a.dove_bonsai);
    } else if (a.cerca === 'senza-cure') base = 'verde-stabilizzato-muschio-e-licheni-stabilizzati-i-giardini-di-giulia';
    else if (a.cerca === 'regalo') base = 'selezione-e-idee-piante-da-regalo';
    else base = 'officine-di-giulia';
    prezzo();
    return ROOT + 'collections/' + base + (q.length ? '?' + q.join('&') : '');
  }

  // ---------- interfaccia ----------
  var ui = { box: null, modale: false, overlay: null };
  var stato = { passo: 0, risposte: {}, prezzo: 'tutti', focus: null };

  function schermata(html) {
    if (!ui.box) return;
    ui.box.innerHTML = html;
    var scorre = ui.modale ? ui.box.closest('.ggq-modal') : null;
    if (scorre) scorre.scrollTop = 0;
    else if (!ui.modale) { var r = ui.box.getBoundingClientRect(); if (r.top < 0) window.scrollTo({ top: window.pageYOffset + r.top - 90, behavior: 'smooth' }); }
    var t = ui.box.querySelector('h1, h2'); if (t) { t.setAttribute('tabindex', '-1'); try { t.focus({ preventScroll: true }); } catch (x) {} }
  }
  function intro(inline) {
    var tag = inline ? 'h1' : 'h2';
    return '<section class="ggq-screen ggq-intro">' +
      '<div class="ggq-intro-icon">' + ICONE.leaf + '</div>' +
      '<' + tag + ' class="ggq-title">Trova la pianta <em>giusta per te</em></' + tag + '>' +
      '<p class="ggq-lead">Rispondi a 5 domande: ti consigliamo le piante e i prodotti più adatti a casa tua, alla tua luce e al tempo che hai.</p>' +
      '<button type="button" class="ggq-btn ggq-btn-primary" data-ggq="start">Inizia</button>' +
      '</section>';
  }
  function domanda() {
    var a = stato.risposte, ids = percorsoDomande(a), id = ids[stato.passo], d = domandaDef(id, a);
    var totale = a.cerca === undefined ? 5 : Math.max(ids.length, stato.passo + 1), n = stato.passo + 1;
    var opzioni = d.opzioni.slice(); if (d.ns) opzioni.push([NS, 'Non saprei', d.ns]);
    var opz = opzioni.map(function (o) {
      var sel = a[id] === o[0] ? ' is-selected' : '';
      return '<button type="button" class="ggq-option' + sel + (o[0] === NS ? ' ggq-option-ns' : '') + '" data-ggq="scegli" data-id="' + e(id) + '" data-val="' + e(o[0]) + '">' +
        '<span class="ggq-option-text"><span class="ggq-option-title">' + e(o[1]) + '</span>' + (o[2] ? '<span class="ggq-option-desc">' + e(o[2]) + '</span>' : '') + '</span>' +
        '<span class="ggq-option-check">' + ICONE.check + '</span></button>';
    }).join('');
    return '<section class="ggq-screen ggq-question">' +
      '<div class="ggq-progress" role="progressbar" aria-valuemin="1" aria-valuemax="' + totale + '" aria-valuenow="' + n + '">' +
      '<div class="ggq-progress-row"><span class="ggq-progress-label">' + n + ' di ' + totale + '</span>' +
      (stato.passo > 0 ? '<button type="button" class="ggq-back" data-ggq="indietro">' + ICONE.back + 'Indietro</button>' : '') + '</div>' +
      '<div class="ggq-progress-bar"><span style="width:' + Math.round(n / totale * 100) + '%"></span></div></div>' +
      '<h2 class="ggq-title ggq-q-title">' + e(d.titolo) + '</h2>' +
      '<div class="ggq-options">' + opz + '</div></section>';
  }
  function caricamento() { return '<section class="ggq-screen ggq-loading"><div class="ggq-spinner" aria-hidden="true"></div><p>Stiamo scegliendo le proposte più adatte tra i prodotti disponibili…</p></section>'; }
  function errore() { return '<section class="ggq-screen ggq-loading"><p>Non riusciamo a caricare i prodotti in questo momento.</p><button type="button" class="ggq-btn ggq-btn-primary" data-ggq="risultati">Riprova</button> <button type="button" class="ggq-btn ggq-btn-ghost" data-ggq="rifai">Rifai il quiz</button></section>'; }

  function card(p, a, opz) {
    opz = opz || {};
    var acquista = p.s === 1 ? '' : '<button type="button" class="ggq-btn ggq-btn-primary ggq-add" data-ggq="aggiungi" data-v="' + e(p.v) + '">Aggiungi al carrello</button>';
    var why = opz.piccola ? '' : perche(p, a, opz.migliore);
    return '<article class="ggq-card' + (opz.piccola ? ' ggq-card-small' : '') + '">' +
      (opz.badge ? '<span class="ggq-badge">' + e(opz.badge) + '</span>' : '') +
      '<a class="ggq-card-media" href="' + e(p.u) + '"><img src="' + e(p.i) + '" alt="' + e(p.t) + '" loading="lazy" width="500" height="500"></a>' +
      '<div class="ggq-card-body"><h3 class="ggq-card-title"><a href="' + e(p.u) + '">' + e(p.t) + '</a></h3>' +
      '<p class="ggq-card-price">' + euro(p.p) + '</p>' +
      (why ? '<p class="ggq-card-why"><strong>Perché te la consigliamo:</strong> ' + e(why) + '</p>' : '') +
      (opz.biglietto ? '<p class="ggq-card-note">Puoi aggiungere un biglietto con il tuo messaggio</p>' : '') +
      '<div class="ggq-card-actions">' + acquista + '<a class="ggq-link' + (p.s === 1 ? ' ggq-btn ggq-btn-primary' : '') + '" href="' + e(p.u) + '">Scopri</a></div>' +
      '<p class="ggq-card-msg" role="status" aria-live="polite"></p></div></article>';
  }

  function risultati() {
    var a0 = stato.risposte, a = {};
    Object.keys(a0).forEach(function (k) { a[k] = a0[k]; });
    if (a.cerca === 'pianta') a.budget = stato.prezzo; // per le piante il budget e un filtro sui risultati
    schermata(caricamento());
    caricaDati().then(function () {
      var larg = 0, lista3 = candidati(a, 0);
      if (lista3.length < 3) { larg = 1; lista3 = candidati(a, 1); }
      if (lista3.length < 3) { larg = 2; lista3 = candidati(a, 2); }
      var scelte = lista3.slice(0, 3).map(function (x) { return x.p; });
      var usati = {}; scelte.forEach(function (p) { usati[p.h] = 1; });
      var migliore = null; scelte.forEach(function (p) { if (rank(p) < 999999 && (!migliore || rank(p) < rank(migliore))) migliore = p; });

      var extra = null;
      if (a.cerca === 'pianta' && a.luce === 'Poca luce' && a.tempo === 'poco') {
        var sc = candidati({ cerca: 'senza-cure', budget: a.budget }, 0);
        if (!sc.length) sc = candidati({ cerca: 'senza-cure' }, 1);
        for (var i = 0; i < sc.length; i++) if (!usati[sc[i].p.h]) { extra = sc[i].p; break; }
      }
      var acc = null;
      if (a.cerca === 'bonsai' && a.esperienza === 'primo') {
        var accs = dati.lista.filter(function (p) { return lista(p.r).indexOf('accessorio') !== -1 && p.v && p.p; });
        var perBonsai = accs.filter(function (p) { return /bonsai/.test(low(p.t) + ' ' + low(p.ty)); });
        var pool = perBonsai.length ? perBonsai : accs;
        pool.sort(function (x, y) { return rank(x) - rank(y) || x.p - y.p; });
        acc = pool[0] || null;
      }

      var ids = percorsoDomande(a0), voci = [];
      ids.forEach(function (id) { if (id !== 'cerca' && a0[id] !== undefined && RIEPILOGO[id]) voci.push(RIEPILOGO[id][a0[id]] || a0[id]); });
      var html = '<section class="ggq-screen ggq-results">' +
        (voci.length ? '<p class="ggq-summary">' + e(voci.join(' · ')) + '</p>' : '') +
        '<h2 class="ggq-title">' + e(TITOLI[a.cerca] || 'Scelti per te') + '</h2>' +
        (a.cerca === 'senza-cure' ? '<p class="ggq-lead ggq-lead-left">Niente acqua, niente luce, niente potature: restano belli nel tempo.</p>' : '');
      if (a.cerca === 'pianta') {
        html += '<div class="ggq-filters" role="group" aria-label="Prezzo">' + [['tutti', 'Tutti'], ['b30', 'Fino a 30 €'], ['b70', '30-70 €'], ['b70p', 'Oltre 70 €']].map(function (f) {
          return '<button type="button" class="ggq-filter' + (stato.prezzo === f[0] ? ' is-active' : '') + '" data-ggq="prezzo" data-val="' + f[0] + '" aria-pressed="' + (stato.prezzo === f[0]) + '">' + f[1] + '</button>';
        }).join('') + '</div>';
      }
      if (larg > 0 && scelte.length) html += '<p class="ggq-note">Non abbiamo trovato abbastanza prodotti con tutte le tue risposte: ti mostriamo i più adatti, allargando un po\' la ricerca.</p>';
      if (!scelte.length) html += '<p class="ggq-note">Non abbiamo trovato prodotti disponibili con queste risposte. Prova a cambiare qualche scelta.</p>';
      html += '<div class="ggq-grid">' + scelte.map(function (p) {
        var top = migliore && p.h === migliore.h;
        return card(p, a, { badge: top ? 'Più venduta' : '', migliore: top, biglietto: a.cerca === 'regalo' });
      }).join('') + '</div>';
      if (extra) html += '<div class="ggq-extra"><h3 class="ggq-extra-title">Poca luce e poco tempo? Prova il verde che non ha bisogno di cure</h3><div class="ggq-grid ggq-grid-one">' + card(extra, { cerca: 'senza-cure' }) + '</div></div>';
      if (acc) html += '<div class="ggq-extra"><h3 class="ggq-extra-title">Per iniziare bene, aggiungi:</h3><div class="ggq-grid ggq-grid-one">' + card(acc, a, { piccola: true }) + '</div></div>';
      html += '<div class="ggq-end"><a class="ggq-btn ggq-btn-ghost" href="' + e(linkCollezione(a)) + '">Vedi tutti i prodotti adatti</a>' +
        '<button type="button" class="ggq-btn ggq-btn-link" data-ggq="rifai">Rifai il quiz</button></div></section>';
      schermata(html);
    }).catch(function () { schermata(errore()); });
  }

  function aggiungi(btn) {
    var v = parseInt(btn.getAttribute('data-v'), 10); if (!v) return;
    var card = btn.closest('.ggq-card'), msg = card && card.querySelector('.ggq-card-msg');
    btn.disabled = true; btn.classList.add('is-loading');
    fetch(ROOT + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: v, quantity: 1 }], sections: ['cart-ajax'] }) // cart-ajax: serve al carrello a tendina per aprirsi
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (prodotto) {
        btn.classList.remove('is-loading'); btn.classList.add('is-done');
        btn.innerHTML = ICONE.check + 'Aggiunto al carrello';
        setTimeout(function () {
          if (ui.modale) chiudi();
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: prodotto } }));
          document.dispatchEvent(new CustomEvent('cart:build'));
          btn.disabled = false;
        }, 900);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading'); btn.disabled = false;
        if (err && err.status === 422 && err.message === 'Spedizione su pallet') return; // gestito dalla regola dei pallet
        if (msg) msg.textContent = (err && err.description) ? err.description : 'Non è stato possibile aggiungerlo al carrello. Apri la scheda con "Scopri".';
      });
  }

  function vai() {
    var ids = percorsoDomande(stato.risposte);
    if (stato.passo >= ids.length) return risultati();
    schermata(domanda());
  }
  function scegli(id, val, el) {
    if (el) { ui.box.querySelectorAll('.ggq-option').forEach(function (b) { b.classList.remove('is-selected'); }); el.classList.add('is-selected'); }
    var a = stato.risposte;
    a[id] = val;
    var ids = percorsoDomande(a);
    Object.keys(a).forEach(function (k) { if (ids.indexOf(k) === -1) delete a[k]; });
    if (id === 'cerca') caricaDati().catch(function () {});
    setTimeout(function () { stato.passo++; vai(); }, 180);
  }
  function azzera() { stato.passo = 0; stato.risposte = {}; stato.prezzo = 'tutti'; }

  function gestisci(ev) {
    var t = ev.target.closest('[data-ggq]'); if (!t) return;
    var az = t.getAttribute('data-ggq');
    if (az === 'start') { azzera(); caricaDati().catch(function () {}); return vai(); }
    if (az === 'scegli') return scegli(t.getAttribute('data-id'), t.getAttribute('data-val'), t);
    if (az === 'indietro') { stato.passo = Math.max(0, stato.passo - 1); return vai(); }
    if (az === 'rifai') { azzera(); return vai(); }
    if (az === 'risultati') return risultati();
    if (az === 'prezzo') { stato.prezzo = t.getAttribute('data-val'); return risultati(); }
    if (az === 'aggiungi') { ev.preventDefault(); return aggiungi(t); }
    if (az === 'chiudi') return chiudi();
  }

  // ---------- apertura: finestra o dentro la pagina ----------
  function montaInline(el) {
    ui.box = el; ui.modale = false;
    el.classList.add('ggq-inline');
    el.addEventListener('click', gestisci);
    azzera();
    el.innerHTML = intro(true);
  }
  function apri() {
    var inline = document.querySelector('[data-ggq-inline]');
    if (inline && ui.box === inline) { inline.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    var root = document.getElementById('ggq-root'); if (!root) return;
    stato.focus = document.activeElement;
    root.innerHTML = '<div class="ggq-overlay" data-ggq-overlay><div class="ggq-modal" role="dialog" aria-modal="true" aria-label="Trova la pianta giusta per te" tabindex="-1">' +
      '<button type="button" class="ggq-close" data-ggq="chiudi" aria-label="Chiudi">' + ICONE.close + '</button><div class="ggq-content"></div></div></div>';
    ui.overlay = root.querySelector('.ggq-overlay'); ui.box = root.querySelector('.ggq-content'); ui.modale = true;
    root.removeAttribute('aria-hidden');
    ui.overlay.addEventListener('click', function (ev) { if (ev.target === ui.overlay) chiudi(); else gestisci(ev); });
    document.documentElement.classList.add('ggq-lock');
    requestAnimationFrame(function () { ui.overlay.classList.add('is-open'); });
    azzera();
    schermata(intro(false));
    caricaDati().catch(function () {});
  }
  function chiudi() {
    if (!ui.modale || !ui.overlay) return;
    ui.overlay.classList.remove('is-open');
    document.documentElement.classList.remove('ggq-lock');
    var root = document.getElementById('ggq-root');
    setTimeout(function () { if (root) { root.innerHTML = ''; root.setAttribute('aria-hidden', 'true'); } }, 250);
    ui.modale = false; ui.box = null; ui.overlay = null;
    var inline = document.querySelector('[data-ggq-inline]'); if (inline && inline.classList.contains('ggq-inline')) ui.box = inline;
    if (stato.focus && stato.focus.focus) try { stato.focus.focus(); } catch (x) {}
  }
  document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && ui.modale) chiudi(); });
  window.ggqOpen = apri; window.ggqClose = chiudi;

  function avvio() {
    var inline = document.querySelector('[data-ggq-inline]');
    if (inline) montaInline(inline);
    document.querySelectorAll('[data-ggq-open], a[href$="#quiz"], a[href*="?quiz=1"]').forEach(function (a) {
      if (a.closest('[data-ggq-inline]')) return;
      a.addEventListener('click', function (ev) { ev.preventDefault(); apri(); });
    });
    try { var qs = new URLSearchParams(location.search); if (!inline && (qs.get('quiz') === '1' || location.hash === '#quiz')) setTimeout(apri, 300); } catch (x) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvio); else avvio();
})();
